import dayjs from 'dayjs';
import es from 'dayjs/locale/es';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.locale(es);

export const chileTimeZone = 'America/Santiago';

dayjs.tz.setDefault(chileTimeZone);

export const dateFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

export const getInitialProductDate = (date: Date) => {
  const dateInDayjsFormat = dayjs(date).tz();
  const dateFormatted = dateInDayjsFormat.startOf('day').format(dateFormat);
  return dateFormatted;
};

export const getEndProductDate = (date: Date) => {
  const dateInDayjsFormat = dayjs(date).tz();
  const dateAddedOneYear = dateInDayjsFormat.add(1, 'year');
  const dateLessOneDay = dateAddedOneYear.subtract(1, 'day');
  const dateFormatted = dateLessOneDay.startOf('day').format(dateFormat);
  return dateFormatted;
};

export const getSaleDate = (date: Date) => {
  const dateInDayjsFormat = dayjs(date).tz();
  const dateFormatted = dateInDayjsFormat.format('YYYY-MM-DD');
  return dateFormatted;
};

export const getSaleTime = (date: Date) => {
  const dateInDayjsFormat = dayjs(date).tz();
  const timeFormatted = dateInDayjsFormat.format('HH:mm:ss');
  return timeFormatted;
};

export const getStringDate = (date: Date, format = 'YYYY-MM-DD') => {
  return dayjs.utc(date).format(format);
};

export const isDateSameToToday = (date: Date): boolean => {
  const todayFormatted = dayjs().tz().format('YYYY-MM-DD');
  const dateFormatted = dayjs(date).utc().format('YYYY-MM-DD');
  const result = todayFormatted === dateFormatted;
  return result;
};

export default dayjs;
